import { generatePath } from 'react-router-dom'

import { AnalyticsContextType } from '@acorns/web-utils'
import { object, string } from 'yup'

import { CloseAccountReason } from 'generated/types'

import { EarlyClosureContinueTapped } from './segment'

type Props = {
  isWebView: boolean
  hasLaterAccount: boolean
  hasSpendAccount: boolean
  hasLaterBalance: boolean
  shuffledReasons: CloseAccountReason
  analytics: AnalyticsContextType
}
export interface FormValues {
  reason: string
}

export const validationSchema = object().shape({
  reason: string().required(),
})

export const handleSubmit = (
  values,
  { props: { shuffledReasons, history, isWebView, earlyRoutes, analytics } },
) => {
  analytics.track('Button Tapped', EarlyClosureContinueTapped(values.reason))
  const findLabel = (selection: {
    label: CloseAccountReason['label']
    value: CloseAccountReason['key']
  }) => {
    return selection.value === values.reason
  }
  const userSelection: {
    label: CloseAccountReason['label']
    value: CloseAccountReason['key']
  } = shuffledReasons.find(findLabel)

  sessionStorage.setItem('earlyClosureFormReason', userSelection.label)
  sessionStorage.setItem('earlyClosureFormReasonKey', values.reason)

  const state = {
    referrer: earlyRoutes.index,
    earlyClosureFormReasonKey: values.reason,
    earlyClosureFormReason: userSelection.label,
  }
  const url = isWebView
    ? `/wv${earlyRoutes.accountSelection}`
    : earlyRoutes.accountSelection

  history.push(generatePath(url), state)
}

export const mapPropsToValues = (props) => {
  const { reason = '' } = props

  return {
    reason,
  }
}
